import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=fcb0e886&"
import script from "./Panel.vue?vue&type=script&lang=js&"
export * from "./Panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcb0e886')) {
      api.createRecord('fcb0e886', component.options)
    } else {
      api.reload('fcb0e886', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=fcb0e886&", function () {
      api.rerender('fcb0e886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/drag/components/Panel.vue"
export default component.exports